// Constante para definir quantas cores queremos na nossa paleta.
const N_CORES_GERADAS = 50

// Cache da paleta para evitar recriá-la a cada chamada da função.
// A paleta é gerada apenas na primeira vez que a função for chamada.
const mPaletaCores = gerarPaletaDistinta(N_CORES_GERADAS)

/**
 * @description
 * Gera uma cor visualmente distinta a partir de uma string (ex: id do contato).
 * Utiliza uma paleta de cores gerada programaticamente para garantir boa
 * distribuição e minimizar colisões em grupos grandes. A paleta é gerada
 * uma única vez e armazenada em cache para máxima eficiência.
 *
 * @param {object} theme O tema do Material-UI, usado para obter a cor padrão.
 * @param {string} cContatoId O ID do contato a ser usado para gerar a cor.
 * @returns {string} A cor calculada no formato HEX (ex: "#34ab67").
 */
export function conversaGrupoContatoCorGerar(theme, cContatoId) {
  // Verifica se o ID do contato é válido e se a paleta de cores foi gerada.
  // Se não for válido, retorna uma cor padrão.
  if (!cContatoId || !mPaletaCores?.length > 0) {
    return theme.palette.primary200
  }

  // Converte o ID para string para segurança, depois para número.
  const sId = String(cContatoId || "")
  const nNumero = parseInt(sId, 10)

  // Calcula o índice usando o operador módulo (resto da divisão).
  let nIndex = nNumero % mPaletaCores.length

  if (isNaN(nIndex)) {
    nIndex = 0
  }

  // Retorna a cor da paleta que está no índice calculado.
  return mPaletaCores[nIndex]
}

/**
 * Gera uma paleta de cores
 */
function gerarPaletaDistinta(nQuantidadeGerar) {
  const mPaleta = []
  const nSaturacao = 80 // Saturação em %
  const nLuminosidade = 65 // Luminosidade em %

  for (let nContador = 0; nContador < nQuantidadeGerar; nContador++) {
    const nMatiz = Math.floor((nContador * 360) / nQuantidadeGerar)

    mPaleta.push(hslParaHex(nMatiz, nSaturacao, nLuminosidade))
  }

  return mPaleta
}

/**
 * Converte uma cor do formato HSL para o formato HEX.
 */
function hslParaHex(nMatiz, nSaturacao, nLuminosidade) {
  const nLuminosidadeNormalizada = nLuminosidade / 100
  const nAux = (nSaturacao * Math.min(nLuminosidadeNormalizada, 1 - nLuminosidadeNormalizada)) / 100

  const calcularComponente = (nIndice) => {
    const nK = (nIndice + nMatiz / 30) % 12
    const nCor = nLuminosidadeNormalizada - nAux * Math.max(Math.min(nK - 3, 9 - nK, 1), -1)
    return Math.round(255 * nCor)
      .toString(16)
      .padStart(2, "0")
  }

  return `#${calcularComponente(0)}${calcularComponente(8)}${calcularComponente(4)}`
}
